export default __webpack_public_path__ + "static/media/600.bbcef3af.jpg";